import { SoundType } from '@slot-nx/core'
import { SweetBombSoundType } from './domain/soundManager/enum/soundType'

// commonv2
import spin_sound from '../asset/sounds/common/spin.mp3'
import click from '../asset/sounds/common/click.mp3'
import btn_close from '../asset/sounds/common/button_close.mp3'
import stake_minus from '../asset/sounds/common/stake_minus.mp3'
import stake_plus from '../asset/sounds/common/stake_plus.mp3'
import bigWin from '../asset/sounds/common/big_win.mp3'
import megaWin from '../asset/sounds/common/mega_win.mp3'
import superMegaWin from '../asset/sounds/common/super_mega_win.mp3'
import winningEnd from '../asset/sounds/common/winning_end.mp3'
// in game
import mg_bgm from '../asset/sounds/mg_bgm.mp3'
import fg_bgm from '../asset/sounds/fg_bgm.mp3'
import fg2_bgm from '../asset/sounds/fg2_bgm.mp3'

import multiplier_suck_away from '../asset/sounds/multiplier_suck_away.mp3'
import stop from '../asset/sounds/stop.mp3'
import stop_turbo from '../asset/sounds/stop_turbo.mp3'
import bomb_explode from '../asset/sounds/bomb_explode.mp3'
import add_multiplier from '../asset/sounds/add_multiplier.mp3'
import candy_machine from '../asset/sounds/candy_machine.mp3'
import multi_tumble_add from '../asset/sounds/multi_tumble_add.mp3'
import multi_tumble_add2 from '../asset/sounds/multi_tumble_add2.mp3'
import sym_eliminate from '../asset/sounds/sym_eliminate.mp3'
import sym_scatter1 from '../asset/sounds/sym_scatter1.mp3'
import sym_scatter2 from '../asset/sounds/sym_scatter2.mp3'
import scatter_peek from '../asset/sounds/scatter_peek.mp3'
import scatter1_trigger from '../asset/sounds/scatter1_trigger.mp3'
import scatter2_trigger from '../asset/sounds/scatter2_trigger.mp3'
import button_buy from '../asset/sounds/button_buy.mp3'
import boost from '../asset/sounds/boost.mp3'
import add_fg_spins from '../asset/sounds/add_fg_spins.mp3'
import fg1_cutscene from '../asset/sounds/fg1_cutscene.mp3'
import fg2_cutscene from '../asset/sounds/fg2_cutscene.mp3'
import fg_total_win from '../asset/sounds/fg_total_win.mp3'

import godziRoar from '../asset/sounds/godziDrop/godzi_roar.mp3'
import godziCoins from '../asset/sounds/godziDrop/godzi_coins.mp3'
import godziCoinBgm from '../asset/sounds/godziDrop/godzi_coin_bgm.mp3'
import godziShowPrize from '../asset/sounds/godziDrop/godzi_show_prize.mp3'
import godziVictory from '../asset/sounds/godziDrop/godzi_victory.mp3'
import godziOpenEye from '../asset/sounds/godziDrop/godzi_open_eye.mp3'
import { GodziDropSoundType } from './domain/godziDrop/enum/godziDropEnum'

import totalWinPopup from '../asset/sounds/voucher/totalWinPopup.mp3'
import buttonClick from '../asset/sounds/voucher/buttonClick.mp3'
import headerShow from '../asset/sounds/voucher/headerShow.mp3'
import giftIconBounce from '../asset/sounds/voucher/giftIconBounce.mp3'
import selectPopup from '../asset/sounds/voucher/selectPopup.mp3'
import { VoucherSoundType } from './domain/soundManager/enum/VoucherSoundType'

export const gameConfig = {
  name: 'sweetbomb',
  gameCode: 1902610,
  resolution: {
    width: 1080,
    height: 1920,
  },
  spinDuration: 0.25,
  speedModeSpinDuration: 0.2,
  reelDelay: 0.1,
  speedModeReelDelay: 0.08,
  symbolDelay: 0.05,
  speedModeSymbolDelay: 0.01,
  bounceDuration: 0.05,
  speedModeBounceDuration: 0.2,
  stopTimeThreshold: 2000,
  nodeWidth: 165,
  nodeHeight: 165,
  squintTime: 3000,
  squintRate: 0.01,
  autoPlaySpinIntervalMs: 500,
  showPlaceOrderDelayLoadingMs: 1500,
  speedModeShowPlaceOrderDelayLoadingMs: 500,
  autoCloseWinningPanelDurationMs: 2500,
  sounds: [
    { alias: SoundType.bgm, src: mg_bgm },
    { alias: SoundType.spin, src: spin_sound },
    { alias: SoundType.buttonConfirm, src: click },
    { alias: SoundType.buttonClose, src: btn_close },
    { alias: SoundType.stake_minus, src: stake_minus },
    { alias: SoundType.stake_plus, src: stake_plus },
    { alias: 'big_win', src: bigWin },
    { alias: 'mega_win', src: megaWin },
    { alias: 'super_mega_win', src: superMegaWin },
    { alias: 'winning_end', src: winningEnd },

    { alias: SweetBombSoundType.YummyFgBgm, src: fg_bgm },
    { alias: SweetBombSoundType.HeavenlyFgBgm, src: fg2_bgm },
    { alias: SweetBombSoundType.MultiplierSuckAway, src: multiplier_suck_away },
    { alias: SweetBombSoundType.Stop, src: stop },
    { alias: SweetBombSoundType.StopTurbo, src: stop_turbo },
    { alias: SweetBombSoundType.BombExplode, src: bomb_explode },
    { alias: SweetBombSoundType.AddMultiplier, src: add_multiplier },
    { alias: SweetBombSoundType.CandyMachine, src: candy_machine },
    { alias: SweetBombSoundType.MultiTumbleAdd, src: multi_tumble_add },
    { alias: SweetBombSoundType.MultiTumbleAdd2, src: multi_tumble_add2 },
    { alias: SweetBombSoundType.SymEliminate, src: sym_eliminate },
    { alias: SweetBombSoundType.SymScatter1, src: sym_scatter1 },
    { alias: SweetBombSoundType.SymScatter2, src: sym_scatter2 },
    { alias: SweetBombSoundType.ScatterPeek, src: scatter_peek },
    { alias: SweetBombSoundType.Scatter1Trigger, src: scatter1_trigger },
    { alias: SweetBombSoundType.Scatter2Trigger, src: scatter2_trigger },
    { alias: SweetBombSoundType.ButtonBuy, src: button_buy },
    { alias: SweetBombSoundType.Boost, src: boost },
    { alias: SweetBombSoundType.AddFgSpins, src: add_fg_spins },
    { alias: SweetBombSoundType.Fg1Cutscene, src: fg1_cutscene },
    { alias: SweetBombSoundType.Fg2Cutscene, src: fg2_cutscene },
    { alias: SweetBombSoundType.FgTotalWin, src: fg_total_win },

    { alias: GodziDropSoundType.godziRoar, src: godziRoar },
    { alias: GodziDropSoundType.godziCoins, src: godziCoins },
    { alias: GodziDropSoundType.godziCoinBgm, src: godziCoinBgm },
    { alias: GodziDropSoundType.godziShowPrize, src: godziShowPrize },
    { alias: GodziDropSoundType.godziVictory, src: godziVictory },
    { alias: GodziDropSoundType.godziOpenEye, src: godziOpenEye },

    { alias: VoucherSoundType.totalWinPopup, src: totalWinPopup },
    { alias: VoucherSoundType.buttonClick, src: buttonClick },
    { alias: VoucherSoundType.headerShow, src: headerShow },
    { alias: VoucherSoundType.giftIconBounce, src: giftIconBounce },
    { alias: VoucherSoundType.selectPopup, src: selectPopup },
  ],
  languageList: [
    'en',
    'ja',
    'zh',
    'es',
    'th',
    'id',
    'my',
    'ko',
    'ru',
    'vi',
    'fr',
    'pt',
    'hi',
    'ms',
    'es-es',
    'es-la',
    'pt-br',
    'pt-pt',
    'ar',
    'bn',
    'tr',
    'en-sc',
    'mm-sc',
  ],
}

export const gameSupportLanguages = ['EN', 'TH_TH', 'JA_JP', 'VI_VN', 'ZH_TW', 'ZH_CN']
